import PropTypes from 'prop-types';
import Modal from '../../assets/styles/Modal';
import Text from '../../assets/styles/Text';
import ReactPortal from '../ReactPortal';
import * as styles from './styles';

export default function PopUp({
  children,
  show = false,
  title = '',
  white = false,
  onClose = null,
}) {
  if (!show) return null;

  return (
    <ReactPortal containerId="PopUp">
      <Modal>
        <styles.Container $white={white}>
          {onClose && (
            <styles.Close>
              <button type="button" onClick={onClose}>
                X
              </button>
            </styles.Close>
          )}

          <styles.Title>
            <Text.H3>{title}</Text.H3>
          </styles.Title>

          <styles.Description>{children}</styles.Description>
        </styles.Container>
      </Modal>
    </ReactPortal>
  );
}

PopUp.propTypes = {
  children: PropTypes.node.isRequired,
  show: PropTypes.bool,
  title: PropTypes.string,
  white: PropTypes.bool,
  onClose: PropTypes.func,
};
